// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-09-08T08:50:59.453Z",
  gitInfo: {
    dirty: false,
    raw: "6690b1f12",
    hash: "6690b1f12",
    distance: null,
    tag: null,
    semver: null,
    suffix: "6690b1f12",
    semverString: null
  }
};
/* tslint:enable */
